
import { defineComponent } from "vue";
import { ElForm, ElMessage } from "element-plus";
import { RootState } from "@/types/state.type";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import securityService from "@/service/security.service";
import { AppError } from "@/types/app.type";
import * as AuthService from "@/service/auth.service";
import TokenService from "../service/token.service";
import { errorHandlerDefault } from "@/utils/handler.util";

export default defineComponent({
  name: "Login",
  setup() {
    const store = useStore<RootState>();
    const router = useRouter();
    return { store, router };
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      loading: false,
      rules: {
        username: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    loggedIn(): boolean {
      return this.store.getters["auth/loggedIn"];
    },
  },
  created() {
    if (this.loggedIn) {
      this.router.push(securityService.HOME_PAGE);
    }
  },
  methods: {
    /**
     * do login
     */
    async login() {
      // - validate
      const valid = await (this.$refs["form"] as InstanceType<typeof ElForm>).validate();

      if (!valid) throw new Error(AppError.FORM_VALIDATION);

      this.loading = true;

      // - call store login
      this.store
        .dispatch("auth/login", {
          username: this.form.username,
          password: this.form.password,
        })
        .then(() => {
          // - sucess
          if (this.store.getters["auth/loggedIn"]) {
            ElMessage.success(this.$t("success.login"));
            this.router.push(securityService.HOME_PAGE);
          } else {
            throw new Error(AppError.LOGIN_FAILED);
          }
        })
        .catch((e) => errorHandlerDefault(e))
        .finally(() => {
          this.loading = false;
        });
    },
    async ____login() {
      // - validate
      const valid = await (this.$refs["form"] as InstanceType<typeof ElForm>).validate();

      if (!valid) throw new Error(AppError.FORM_VALIDATION);

      this.loading = true;
      await AuthService.logIn(this.form.username, this.form.password)
        .then((userAccess) => {
          this.store.commit("auth/loginSuccess", userAccess);
          TokenService.setUser(userAccess);
        })
        .then(() => {
          ElMessage.success(this.$t("success.login"));
          this.router.push(securityService.HOME_PAGE);
        })
        .catch((e) => {
          this.store.commit("auth/loginFailure");
          throw e;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
});
